import React from 'react'
import SaveOutlined from '@material-ui/icons/SaveOutlined'

export default function SaveOutlinedIcon() {

    return (
        <SaveOutlined />
    )
}